//
// Shop: Search
//

"use strict";

( function($, waTheme) {

    var ProductHeader = (function ($) {

        ProductHeader = function (options) {
            var that = this;

            // DOM
            that.$window = $(window);
            that.$wrapper = options["$wrapper"];

            // VARS
            that.showClass = "shadow show";
            that.scrollTop = 450;

            // INIT
            that.bindEvents();
        };

        ProductHeader.prototype.bindEvents = function () {
            var that = this;

            that.$window.scroll(function () {
                if (that.$window.scrollTop() > that.scrollTop) {
                    that.$wrapper.addClass(that.showClass);
                } else {
                    that.$wrapper.removeClass(that.showClass);
                }
            });
        };

        return ProductHeader;

    })($);

    waTheme.init.shop.ProductHeader = ProductHeader;

    var $wrapper = $('.b-product-header');
    if ($wrapper.length) {
        new window.waTheme.init.shop.ProductHeader({
            $wrapper: $wrapper,
        });
    }

})(jQuery, window.waTheme);
